import { AxiosRequestConfig } from 'axios';

import { Logger } from '@rover/rsdk/src/modules/Logging';

import emitMetric from './emitMetric';

const API_METRIC_PREFIX = 'axios_api_';

export type Response = {
  status?: number;
  data?: Record<string, unknown> | string;
  config?: AxiosRequestConfig<any>;
  response?: Record<string, unknown>;
  responseText?: string;
  headers?: Headers | Record<string, string>;
};

function emitApiCallMetric(
  status: 'success' | 'error',
  api: string,
  method: string,
  tags: Record<string, string> = {}
): void {
  emitMetric(`${API_METRIC_PREFIX}${status}`, { api, method, ...tags });
}

export function emitSuccessApiCallMetric(
  api: string,
  method: string,
  tags?: Record<string, string>
): void {
  emitApiCallMetric('success', api, method, tags);
}

export function emitErrorApiCallMetric(
  api: string,
  method: string,
  tags?: Record<string, string>
): void {
  emitApiCallMetric('error', api, method, tags);
}

function emitGenericErrorApiCallMetric(
  api: string,
  method: string,
  tags: Record<string, string> = {}
): void {
  emitMetric(`${API_METRIC_PREFIX}generic_error`, { api, method, ...tags });
}

export const emitApiErrorMetric = (response: Response) => {
  try {
    const status = (response.status ? response.status : 0).toString();
    const path = response.config?.url || 'unknown';
    const method = response.config?.method?.toUpperCase() || '';
    emitGenericErrorApiCallMetric(path, method, { status });
  } catch (error) {
    if (error instanceof Error) {
      Logger.error(error);
    } else {
      Logger.error(new Error(`Unknown error: ${error}`));
    }
  }
};
